import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './api';
import utils from './utils'
import { installCardDragger } from 'carddragger'//卡片拖拽
import axios from 'axios'
import PuzzleVerification from 'vue-puzzle-verification'
//导入md5.js
import MD5 from "js-md5"
import './blueOceanShopping-theme.scss'

import './assets/style/global.css'//公共样式
import 'lib-flexible'
import VueLazyLoad from 'vue-lazyload'
import loadingImg from './assets/images/loading.gif'

// import './assets/rem.js'//公共样式
Vue.use(ElementUI)

Vue.config.productionTip = false;
Vue.prototype.$http = api;
Vue.prototype.$utils = utils
Vue.use(installCardDragger)
Vue.prototype.$axios = axios;
//将md5转换成vue原型：
Vue.prototype.md5 = MD5
Vue.use(PuzzleVerification)
Vue.use(VueLazyLoad, {
  preload: 1.3, // 预加载高度比例
  attempt: 1,//尝试加载次数
  // loading: loadingImg,
  // attempt: 6, // 尝试加载图片数量
  // observer: true,
  // observerOptions: {
  //   rootMargin: '0px',
  //   threshold: 0.1
  // }
})

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {
      config.headers.token = localStorage.getItem('token');
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  });

// 响应拦截
axios.interceptors.request.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status == 401 || error.response.status == 402) {
      router.push('/login')
      Vue.prototype.$toast.fail('请重新登录')
    }
    return Promise.reject(error);
  });
// (function () {
//   var rem = document.createElement("script");
//   rem.src = "./assets/rem.js";
//   document.body.appendChild(rem);
// })();

// 响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做些什么
  if (response.data.code == 0) {
    if (response.data.exceptionCode == "20002") {
      router.push('/login')
      Vue.prototype.$toast.fail('请重新登录')
    }
  }
  return response
}, error => {
  // 当响应异常时
  let isTimeout = error.toString().includes('timeout')
  if (isTimeout) {
    Vue.prototype.$message({
      message: '请求超时...',
      type: 'warning',
      duration: 2000,
      showClose: true
    })
  }
  let isLogTimeout = error.toString().includes('401')
  if (isLogTimeout) {
    // 登录超时, 跳转至登录界面
    Vue.prototype.$message({
      message: '登录过期，请重新登录',
      type: 'warning',
      duration: 2000,
      showClose: true
    })
    // 重置登录状态
    // Store.commit('updateLoginStatus', false)
    // Router.push({
    //   name: 'Login'
    // })
  }
  return Promise.reject(error)
})
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
